import { render, staticRenderFns } from "./FormStoreReview.vue?vue&type=template&id=38807cea&"
import script from "./FormStoreReview.vue?vue&type=script&lang=js&"
export * from "./FormStoreReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports